import { SystemBaseApi } from "./SystemBaseApi";
import { Methods } from '@newview/infrastructure';

/**
 * Api
 */
export class ModuleinforApi extends SystemBaseApi {
    public get ControllerName(): any {
        return 'moduleinfor'
    }

    /**
     * 保存模块资源
     * @param param 
     */
    public saveOrUpdateModule(param) {
        return this.send(param, "update", Methods.POST)
    }

    /**
     * 查询模块资源列表
     * @param moduleCluster 
     * @param moduleType 
     */
    public getModuleList(moduleCluster, moduleType) {
        return this.send({ moduleCluster: moduleCluster, moduleType: moduleType }, "getModuleList", Methods.GET);
    }
    /**
     * 删除
     * @param ids 
     */
    public deleteModule(ids) {
        return this.send({}, "delete?id=" + ids, Methods.POST)
    }

    /**
     * 删除模块使用的字典
     * @param moduleId 
     * @param bussinesstypeId 
     */
    public deleteByRelationId(moduleId, bussinesstypeId) {
        return this.send({}, "deleteByRelationId?moduleId=" + moduleId + "&bussinesstypeId=" + bussinesstypeId, Methods.POST)
    }

    /**
     * 查询所有子级菜单
     */
    public getChildrenList(moduleCluster) {
        return this.send({ moduleCluster: moduleCluster }, "getChildrenList", Methods.GET);
    }

    /**
     *查询对象，用户回显 
     * @param id 
     */
    public getEntityById(id) {
        return this.send({ id: id }, "getEntity", Methods.GET)
    }

    /**
     * 
     * @param loadType 加载模式（1、动态 2、静态 ）
     * @param moduleType 模块分类（1、web 2、app）
     * @param moduleName 模块名称
     * @returns 
     */
    public getListByParams(loadType, moduleType, moduleName) {
        return this.send({ loadType, moduleType, moduleName }, "getListByParams", Methods.GET);
    }

    /**
     * 修改haschild状态
     * @param moduleinfor 
     */
    public updateChild(moduleinfor){
        return this.send(moduleinfor,'updateChild',Methods.POST)
    }
}